import {ICharMod} from "../_interfaces/ICharMod";
import {signal} from "@preact/signals-core";
import {s_char} from "./s_char";

export const s_chars_mods = signal(new Map<string, Map<string, ICharMod>>());

export const update_s_chars_mods = (mods: ICharMod[]) => {
    let current_chars_mods = s_chars_mods.value;
    const updatedMods = new Map(current_chars_mods);

    mods.forEach(m => {
        const playerId = m.cid;
        const mod = m;

        const playerMods = updatedMods.get(playerId) || new Map();
        playerMods.set(mod.id, mod);
        updatedMods.set(playerId, playerMods);
    });
    console.log('update_s_chars_mods', updatedMods)
    s_chars_mods.value = updatedMods;
}

export const remove_s_chars_mods = (modsToRemove: string[]) => {
    const currentCharsModsMap = s_chars_mods.value;
    console.log('remove_s_chars_mods',currentCharsModsMap)
    const updatedCharsModsMap = new Map(currentCharsModsMap);

    for (const [cid, charModsMap] of currentCharsModsMap.entries()) {
        if (charModsMap) {
            const updatedCharModsMap = new Map<string, ICharMod>();
            for (const [modId, mod] of charModsMap.entries()) {
                if (!modsToRemove.includes(modId)) {
                    updatedCharModsMap.set(modId, mod);
                }
            }
            updatedCharsModsMap.set(cid, updatedCharModsMap);
        }
    }

    console.log('remove_s_chars_mods', updatedCharsModsMap);
    s_chars_mods.value = updatedCharsModsMap;
}